import { useCoreSelector } from '../../CoreStore';
import type { BetType } from '../bets/types';

import type { AutoplayLimits, AutoplayStatus } from './types';

export const useAutoplaySlice = {
  isInProgress: (): boolean => {
    return useCoreSelector(({ autoplay }) => autoplay.isInProgress);
  },
  getAutoplayStatus: (): AutoplayStatus => {
    return useCoreSelector(({ autoplay }) => autoplay.autoplayStatus);
  },
  isOpen: (): boolean => {
    return useCoreSelector(({ autoplay }) => autoplay.isOpen);
  },
  getRemainingCount: (): number => {
    return useCoreSelector(({ autoplay }) => autoplay.roundsLeft);
  },
  getSavedBet: (): BetType | null => {
    return useCoreSelector(({ autoplay }) => autoplay.savedBet);
  },
  isLaunchedMidRound: (): boolean => {
    return useCoreSelector(({ autoplay }) => autoplay.isLaunchedMidRound);
  },
  getAutoplayLimits: (): AutoplayLimits => {
    return {
      singleWinLimit: useCoreSelector(({ autoplay }) => autoplay.singleWinLimit),
      balanceDecreaseLimit: useCoreSelector(({ autoplay }) => autoplay.balanceDecreaseLimit),
      balanceIncreaseLimit: useCoreSelector(({ autoplay }) => autoplay.balanceIncreaseLimit),
    };
  },
};
